const state = {
  rolesData: null
}
const mutations = {
  changeRolesData: (state, obj) => {
    state.rolesData = obj;
  }
}
const actions = {
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/orgRole.js